import { Injectable } from '@angular/core';
import { Observable, BehaviorSubject } from 'rxjs';

@Injectable()
export class DebtorDataService {

    public preSelectDebtorShared: BehaviorSubject<any> = new BehaviorSubject<any>(0);

    constructor() { }

    getPreSelectDebtorSharedData(): Observable<any> {
        return this.preSelectDebtorShared.asObservable();
    }
    setPreSelectDebtorSharedData(data: any) {
        this.preSelectDebtorShared.next(data);
    }

}
